<template>
  <div>
    <h1 class="uppercase text-xl lg:text-3xl mt-10 py-3 px-6 lg:px-0">
      {{ $t('teacher.yourReviews') }}
    </h1>
    <div class="flex flex-col mt-6">
      <review-row v-for="review in reviews" :key="review.id" :review="review" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTeacherReviews } from '@/services/TeacherService';
import ReviewRow from './ReviewRow.vue';

export default {
  components: { ReviewRow },
  data() {
    return {
      reviews: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getReviews();
  },

  methods: {
    getReviews() {
      getTeacherReviews(this.user.slug).then(({ data }) => {
        this.reviews = data;
      });
    },
  },
};
</script>
